<template>
  <div class="Contact">
    <div class="formulier" v-show="!verzonden">
      <h1>Uw factuur</h1>
      <p>Hier kunt u uw facturen van Computus B.V. inzien en downloaden als pdf-bestand. Hiervoor moet u inloggen. <br/>Neem <router-link :to="{name: 'contact'}">contact</router-link> op als u nog geen inloggegevens hebt.</p>
      <form action="javascript:void(0);" @submit="verzend();">
        <div class="fspan">
          <label class="flabel" for="inputGebruikernaam">Gebruikersnaam</label>
          <input id="inputGebruikernaam" name="gebruikersnaam" class="finput" maxlength="250" autofocus v-model="gebruikersnaam" />
        </div>
        <div class="fspan">
          <label class="flabel" for="inputWachtwoord">Wachtwoord</label>
          <input type="password" id="inputWachtwoord" name="wachtwoord" class="finput" maxlength="250" v-model="wachtwoord" />
        </div>
        <div class="fspan">
          <label class="flabel" for="btnSend"></label>
          <input type="submit" value="Inloggen" />&nbsp;&nbsp;&nbsp;
          <router-link :to="{name: 'home'}"><input type="button" value="Annuleren" /></router-link>
        </div>
      </form>
    </div>
    <div class="verzonden" v-show="verzonden">
      <h1>Factuuroverzicht</h1>
      <p>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "contact",
  components: {},
  data() {
    return {
      verzonden: false,
      gebruikersnaam: '',
      wachtwoord: ''
    };
  },
  methods: {
    verzend: function() {
        alert("Inloggen mislukt.");
    }
  }
};
</script>

<style scoped>
.flabel {
  display: inline-block;
  width: 150px;
}

.finput {
  width: 300px;
}

.fspan {
  height: 25px;
  line-height: 25px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.fspan-high {
  height: 300px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.farea {
  width: 300px;
  height: 300px;
  vertical-align: top;
}
</style>